import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { ppaUrls } from 'config/urls';
import { KpiDataMerged, mergeKpiDataWithConfig } from 'utils/ppaHelpers';
import { usePpaQueryFilters } from 'hooks/ppa/usePpaQueryFilters';

export function useFetchKpi(config: any[]) {
    const {
        dim1_id_list,
        dim2_id_list,
        hasResolvedFilterIds,
        startTimestamp,
        endTimestamp,
        hasValidTimePeriod,
        filtersLoading,
        defaultTimePeriodLoading,
    } = usePpaQueryFilters();

    const kpiIds = (config ?? []).map((kpi) => kpi?.kpi_id).filter(Boolean);
    const kpiConfigSignature = JSON.stringify(kpiIds);
    const dim1QueryKey = JSON.stringify(dim1_id_list);
    const dim2QueryKey = JSON.stringify(dim2_id_list);

    const canFetchFilters =
        !filtersLoading &&
        hasResolvedFilterIds &&
        hasValidTimePeriod;

    const { data: kpiCardsData, isLoading, isPending } = useQuery({
        queryKey: ['kpi-cards-data', kpiConfigSignature, startTimestamp, endTimestamp, dim1QueryKey, dim2QueryKey],
        queryFn: async () => {
            const response = await axios.post(ppaUrls.getDashboardKpisUrl, {
                kpi_ids: kpiIds,
                time_period: {
                    start_timestamp: startTimestamp,
                    end_timestamp: endTimestamp,
                },
                filters: {
                    dim1_id_list: dim1_id_list,
                    dim2_id_list: dim2_id_list,
                },
                include_growth: true,
            });
            return response.data;
        },
        enabled: kpiIds.length > 0 && canFetchFilters,
        staleTime: 5 * 60 * 1000,
        refetchOnMount: false,
        refetchOnReconnect: false,
    });

    const kpiData: KpiDataMerged[] = mergeKpiDataWithConfig(kpiCardsData?.kpis || [], config);

    return {
        kpiData,
        isLoading,
        isPending:
            filtersLoading ||
            defaultTimePeriodLoading ||
            !hasResolvedFilterIds ||
            !hasValidTimePeriod ||
            isPending,
        isScopeSelected: hasResolvedFilterIds,
    };
}
